const FONT_FAMILY = 'YS Text';

export enum DTMFCharColor {
    default = 'default',
    accent = 'accent',
}

const BACKGROUND_COLORS = {
    default: '#6083D6',
    accent: '#E75669',
};

const TEXT_COLORS = {
    default: '#F7F7FFE5',
    accent: '#F7F7FFE5',
};

type DrawDTMFCharOptions = {
    ctx: CanvasRenderingContext2D;
    x: number;
    y: number;
    char: string;
    color: DTMFCharColor;
    size: number;
    fontSize?: number;
    charOffsetX?: number;
    charOffsetY?: number;
};

export function drawDTMFChar({
    ctx,
    x,
    y,
    char,
    color,
    size,
    fontSize: fontSizeOption,
    charOffsetX = 0,
    charOffsetY = 0,
}: DrawDTMFCharOptions) {
    const radius = Math.round(size / 2);
    const fontSize = fontSizeOption || Math.floor(size * 0.6);

    ctx.beginPath();
    ctx.arc(x + radius, y + radius, radius, 0, 2 * Math.PI);
    ctx.closePath();
    ctx.fillStyle = BACKGROUND_COLORS[color];
    ctx.fill();

    ctx.textBaseline = 'top';
    ctx.font = `${fontSize}px ${FONT_FAMILY}`;
    ctx.fillStyle = TEXT_COLORS[color];

    const textMetrics = ctx.measureText(char);
    const textWidth = textMetrics.width;
    const textHeight = Math.round(textMetrics.actualBoundingBoxAscent + textMetrics.actualBoundingBoxDescent);
    const textOffsetX = charOffsetX + (size - textWidth) / 2;
    const textOffsetY = charOffsetY + (size - textHeight) / 2;

    ctx.fillText(char, x + textOffsetX, y + textOffsetY);
}
